import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=e4fb19bc&"
import script from "./helpMenu.js?vue&type=script&lang=js&"
export * from "./helpMenu.js?vue&type=script&lang=js&"
import style0 from "./HelpMenu.vue?vue&type=style&index=0&id=e4fb19bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports